module.exports = __webpack_public_path__ + "img/1542491211.71b3d28a.jpg";